import Account from './index';
import AccountQuery from '../Account/accountQuery';
import AccountConf from '../Account/accountConf';
import ManualReconciliation from '../Account/manualReconciliation';
import WalletAccount from '../Account/walletAccount';

export default {
  path: '/home/check/account',
  component: Account,
  children: [
    { path: '/home/check/account/query', component: AccountQuery },
    { path: '/home/check/account/conf', component: AccountConf },
    { path: '/home/check/account/manual', component: ManualReconciliation },
    { path: '/home/check/account/wallet', component: WalletAccount }
  ]
};
